import React from 'react';
import './LoadingAnimation.css';

const LoadingAnimation: React.FC = () => {
    return (
        <div className="button-spinner">
            <div className="spinner"></div>
        </div>
    );
};

export default LoadingAnimation;
